import { useMemo } from 'react';

import type { PayflowTopBarManager } from '@ctct/application-layer';
import type { PayflowTopBarPageStore } from '@ctct/state-client-layer';
import { usePlanGroupFacade, usePartnerSummary } from '@ctct/state-server-layer';

import { useWidgetLifecycle } from '../../hooks/useWidgetLifecycle';

interface Props {
  initializer: Pick<PayflowTopBarManager, 'payflowTopBarInit'>;
  pageStore: PayflowTopBarPageStore;
  flags?: {
    isMWebVariantEnabled?: boolean;
    isDesktopExitHidden?: boolean;
  };
}

export function usePayflowTopBarWidget({ initializer, pageStore, flags = {} }: Props) {
  const planGroupQuery = usePlanGroupFacade();
  const partnerSummaryQuery = usePartnerSummary();

  const { isMWebVariantEnabled, isDesktopExitHidden } = flags;

  const componentProps = useMemo(
    () =>
      initializer.payflowTopBarInit({
        pageStore,
        queries: [planGroupQuery, partnerSummaryQuery],
        flags: {
          isMWebVariantEnabled,
          isDesktopExitHidden,
        },
      }),
    [initializer, pageStore, planGroupQuery, partnerSummaryQuery, isMWebVariantEnabled, isDesktopExitHidden]
  );

  useWidgetLifecycle(componentProps.status, componentProps.lifecycle);

  return componentProps;
}

export type PayflowTopBarWidgetProps = ReturnType<typeof usePayflowTopBarWidget>;
